import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import { agentProductionTerms } from '../../../../../constants';
import { tableViews } from '../../../../../common/components/table/agGrid/tableViews';
import Table from '../../../../../common/components/table/agGrid/Table';
import { officeHistoryTooltips } from '../../../../constants/agentProductionConstants';

const OfficeHistoryTab = ({ agent, isActive, sendToParent, setShouldStickyFooterHide }) => {

    const getOfficeHistoryData = () => {
        const officeHistoryData = agent?.history?.history?.map(office => ({
            ...office,
            display: true,
        })) || [];
        officeHistoryData?.push({
            moveDate: new Date().toISOString(),
            officeId: agent.officeId,
            officeName: agent.officeName,
            display: false,
        });
        return officeHistoryData;
    };

    useEffect(() => {
        if (!isActive) return;
        setShouldStickyFooterHide(true);
        sendToParent();
    }, [isActive]);

    return <>
        <div className="mt-4">
            {!getOfficeHistoryData().length && !agent.officeName.length
                ? <div className="no-Office-data">
                    {agentProductionTerms.officeHistoryNoData}
                </div>
                : <Table
                    tableView={tableViews.officeHistory}
                    rowData={getOfficeHistoryData()}
                    tableTitleWithTooltips={officeHistoryTooltips}
                />
            }
        </div>
    </>;
};

OfficeHistoryTab.propTypes = {
    agent: PropTypes.object,
    isActive: PropTypes.bool,
    sendToParent: PropTypes.func,
};
export default OfficeHistoryTab;
